<script setup lang="ts">
  import { MpLoadingContainer } from '@borg/ui';

  const { t } = useI18n();
  const domain = useDomain();
  const route = useRoute();
  const projectConfig = useProjectConfig();

  const organizationCard = useOrganizationCard.provide();

  const organizationId = route.params.employerId.toString();

  // todo - handle error and reload
  const {
    data: organization,
    pending: pendingOrganization,
    status,
  } = await organizationRepository.get(organizationId);
  const { pending: pendingOrganizationJobs } =
    await organizationJobsRepository.getMany(organizationId);

  const organizationName = computed(() => organization.value?.name ?? undefined);
  const tagTitle = computed(() => {
    const baseTitle = organizationName.value
      ? `${t('ORGANIZATION_PROFILE_PAGE.TITLE')} - ${organizationName.value}`
      : t('ORGANIZATION_PROFILE_PAGE.TITLE');
    return `${baseTitle} | ${projectConfig.title}`;
  });
  const tagImage = computed(() =>
    organization.value?.logoUrl && !!organization.value.logoUrl
      ? organization.value.logoUrl
          .replace(/-\d+x\d+x\d+./, '-600x315x85.')
          .replace(/-fit-/, '-frame-')
      : undefined,
  );
  const tagImageWidth = computed(() => (tagImage.value ? 600 : undefined));
  const tagImageHeight = computed(() => (tagImage.value ? 315 : undefined));

  useHead({
    title: tagTitle,
    link: [{ rel: 'canonical', href: `${domain.value}${route.path}`.replace(/\/$/, '') }],
  });

  useSeoMeta({
    ogTitle: tagTitle,
    ogImage: tagImage,
    ogImageWidth: tagImageWidth,
    ogImageHeight: tagImageHeight,
  });

  async function fixSlug() {
    const route = useRoute();
    const routeSlug = (route.params.slug?.toString() ?? '').toLowerCase();
    const itemSlug = (organization.value?.slug ?? '').toLowerCase();

    if (organization.value && routeSlug !== itemSlug) {
      const getRouteBaseName = useRouteBaseName();
      const routeBaseName = getRouteBaseName(route);
      logger.info(
        `Fix organization slug on '${routeBaseName}' :: ${organization.value.id} :: ${routeSlug} ==> ${itemSlug}`,
      );
      await navigate(
        {
          name: 'employers-employerId-slug',
          params: { slug: itemSlug },
          query: route.query,
        },
        { replace: true },
      );
    }
  }

  watch(
    status,
    async (value) => {
      if (value === 'success') {
        await fixSlug();
      } else if (value === 'error') {
        showError({
          statusCode: 404,
          message: 'Job not found',
        });
      }
    },
    { immediate: true },
  );

  watch(
    organization,
    (value) => {
      if (value) {
        organizationCard.set(value);
      }
    },
    { immediate: true },
  );
</script>

<template>
  <MpLoadingContainer :is-loading="pendingOrganization || pendingOrganizationJobs">
    <NuxtPage />
  </MpLoadingContainer>
</template>
